/* eslint-disable import/prefer-default-export */

export const BREADCRUMB_HEIGHT = 46

export const SIDEBAR_WIDTH = 210

export const TABLE_DIVIDER_THICKNESS = 4

export const TAB_CONTENT_HEIGHT = 'calc(100% - 205px)'

export const TABS_WITH_LINE_HEIGHT = 42
